import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { Button } from '@progress/kendo-react-buttons';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    retirableAccounts: ReportData[];
}

type ReportData = {
    AccountID: number;
    AccountName: string;
    BillingEmail: string;
}

class RetirableAccounts extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            retirableAccounts: [],
        }
    }

    public componentWillMount() {
        this.getReport();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Retirable Accounts" />
            <h1>Retirable Accounts</h1>
            { this.renderReportTable() }
        </React.Fragment>;
    }

    private renderReportTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Account Name</th>
                    <th>Account Email</th>
                    <th>Retire Account</th>
                </tr>
            </thead>
            <tbody>
                {this.state.retirableAccounts.map((retirableAccount, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/accounts/${ retirableAccount.AccountID }` }>
                                {retirableAccount.AccountName}
                            </Link>
                        </td>
                        <td>{retirableAccount.BillingEmail}</td>
                        <td><Button onClick={() => this.retireAccount(retirableAccount.AccountID)}  className="btn btn-danger">Retire Account</Button></td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private getReport() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('/api/Reports/retirableAccounts', data, 'POST')
            .then((retirableAccounts: ReportData[]) => {
                this.setState({ retirableAccounts })
            })
    }

    private retireAccount(AccountID: number) {
        if (confirm("Retire Account?")) {
            fetchApi(`api/Account/RetireAccount/${AccountID}`, {} , 'POST')
                .then(() => this.getReport())
        }
    }
}

export default RetirableAccounts;
